import { Moon, Sun, Download } from "lucide-react";
import { motion } from "framer-motion";

export const Header = ({ theme, onToggleTheme, onDownload, downloadAvailable }) => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
    className="fixed top-0 inset-x-0 z-50 border-b border-border bg-white/70 dark:bg-black/60 backdrop-blur-xl"
    data-testid="site-header"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
      <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 group">
        <img src="/logo.png" alt="YIIS-100 logo" data-testid="brand-logo-image" className="w-8 h-8 rounded-md" />
        <span className="font-display font-semibold tracking-tight text-lg">YKD ENTERPRISES</span>
        <span className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground group-hover:text-accent transition-colors duration-300">
          / YIIS-100
        </span>
      </a>

      <nav className="hidden md:flex items-center gap-8 font-mono text-xs tracking-[0.2em] uppercase">
        <a href="#manifesto" data-testid="nav-manifesto" className="text-muted-foreground hover:text-foreground transition-colors duration-300">
          Manifesto
        </a>
        <a href="#modules" data-testid="nav-modules" className="text-muted-foreground hover:text-foreground transition-colors duration-300">
          Modules
        </a>
        <a href="#showcase" data-testid="nav-showcase" className="text-muted-foreground hover:text-foreground transition-colors duration-300">
          Interface
        </a>
        <a href="#download" data-testid="nav-download" className="text-muted-foreground hover:text-foreground transition-colors duration-300">
          Download
        </a>
        <a href="/help" data-testid="nav-help" className="text-muted-foreground hover:text-foreground transition-colors duration-300">
          Guide
        </a>        <a href="/ipo-portfolio-tracker" data-testid="nav-ipo-tracker" className="text-muted-foreground hover:text-foreground transition-colors duration-300">
          IPO Tracker
        </a>
      </nav>

      <div className="flex items-center gap-3">
        <button
          onClick={onToggleTheme}
          data-testid="theme-toggle-button"
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
          aria-pressed={theme === "dark"}
          title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
          className="h-9 flex items-center justify-center gap-2 px-3 border border-border hover:border-accent hover:text-accent transition-colors duration-300"
        >
          {theme === "dark" ? <Sun size={15} /> : <Moon size={15} />}
          <span className="font-mono text-[9px] sm:text-[10px] tracking-[0.14em] uppercase">
            {theme === "dark" ? "Light" : "Dark"}
          </span>
        </button>
        <button
          onClick={onDownload}
          disabled={downloadAvailable !== true}
          aria-label={downloadAvailable === null ? "Connecting to download service" : downloadAvailable ? "Download YIIS-100 installer" : "Installer unavailable"}
          data-testid="header-download-button"
          className="hidden sm:flex items-center gap-2 px-5 py-2 bg-foreground text-background font-mono text-xs tracking-[0.15em] uppercase hover:bg-accent hover:text-accent-foreground transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-foreground disabled:hover:text-background"
        >
          <Download size={14} />
          {downloadAvailable === null ? "Connecting..." : downloadAvailable ? "Get .exe" : "Unavailable"}
        </button>
      </div>
    </div>
  </motion.header>
);
